var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('a',{staticClass:"btn-whatsapp",attrs:{"target":"_blank","href":_vm.link},on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default",function(){return [_c('span',{staticClass:"fa fa-whatsapp"})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }